import { Component, OnInit } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'app-who',
    templateUrl: './who.component.html',
    styles: [],
    standalone: false
})
export class WhoComponent implements OnInit {
  carouselIndex = 1

  ngOnInit(): void {}
}
